import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WebStorage {

    constructor(@Inject(PLATFORM_ID) private platformId: any) {}


    public StoredLead= new BehaviorSubject<any>(isPlatformBrowser(this.platformId) && sessionStorage.getItem('LeadEntityId') ? JSON.parse(sessionStorage.getItem('LeadEntityId')) : 0);
    public CustomerCoordinates= new BehaviorSubject<any>(isPlatformBrowser(this.platformId) && sessionStorage.getItem('CustomerCoordinates') ? JSON.parse(sessionStorage.getItem('CustomerCoordinates')) : 0);
    public CustomerGoogleAddress= new BehaviorSubject<any>(isPlatformBrowser(this.platformId) && sessionStorage.getItem('CustomerGoogleAddress') ? JSON.parse(sessionStorage.getItem('CustomerGoogleAddress')) : 0);
    public AvailablePackages= new BehaviorSubject<any>(isPlatformBrowser(this.platformId) && sessionStorage.getItem('AvailablePackages') ? JSON.parse(sessionStorage.getItem('AvailablePackages')) : 0);
    public CartInfo = new BehaviorSubject<any>(isPlatformBrowser(this.platformId) && sessionStorage.getItem('cartInfo') ? JSON.parse(sessionStorage.getItem('cartInfo')) : 0);
    public CustomerName = new BehaviorSubject<any>(0);
    public CustommerAmountOutstanding = new BehaviorSubject<any>(0);


    private cartProducts: Array<any> = [];
    private packageToCart: any;
    /**
     * Available Packages function
     * @param packages
     */
    public StorePackages(packagesValue: any): void {
        this.AvailablePackages.next(packagesValue);
        sessionStorage.setItem('AvailablePackages', JSON.stringify(packagesValue));
    }

    /**
     * Set LeadEntityID
     * @param leadEntityID
     */
    public SetLeadEntityID(leadEntityID: number): void {
        this.StoredLead.next(leadEntityID);
        sessionStorage.setItem('LeadEntityId', JSON.stringify(leadEntityID));
    }

    /**
     * Set Customer Coordinates
     * 
     */
    public SetCustomerCoordinates(cords: any) {
        sessionStorage.removeItem('CustomerCoordinates');
        this.CustomerCoordinates.next(cords)
        sessionStorage.setItem('CustomerCoordinates', JSON.stringify(cords));
    }
      
    /**
     * Set Customer Google Address
     * 
     */
    public SetCustomerGoogleAddress(place: any) {
        sessionStorage.removeItem('CustomerGoogleAddress');
        this.CustomerGoogleAddress.next(place)
        sessionStorage.setItem('CustomerGoogleAddress', JSON.stringify(place));
    }

    /**
  * Update Cart Badge function
  * @param value 
  * @param PackageEntityID 
  * @param LeadEntityID 
  */
  public async UpdateCart(value: string, item?: any, LeadEntityID?: any): Promise<any> {

    if (value == 'add') {
      this.packageToCart = {
        PackageEntityID: item?.PackageEntityID,
        LeadEntityID: LeadEntityID,
        Price: item.RecurringTotal ?? item.Billing_TotalTempIncl
      };

      this.CartInfo.next(this.packageToCart);
      sessionStorage.setItem('cartInfo', JSON.stringify(this.packageToCart));
      return true
    } else {

      // filter the package
      this.CartInfo.next(0);
      // store in local and subject
      sessionStorage.removeItem('cartInfo');
      return true
    }
  }

    /**
     * Set Customer Name
     * 
     */
    public setCustomerName(name: string) {
      this.CustomerName.next(name)
  }

   /**
     * Set Customer Outstanding Amount
     * 
     */
   public setCustomerOustandingAnout(amount: number) {
    this.CustommerAmountOutstanding.next(amount)
}

}
